// extracted by mini-css-extract-plugin
export var active = "_ff-2";
export var recordingDot = "_ff-1";
export var recordingIndicator = "_ff-0";